export class AppointmentDataStruct {
    public idPatientAppointment: number;
    public patientToken: string;
    public attendantToken: string;
    public patientName: string;
    public idAttendantUser: number;
    public attendantUserName: string;
    public roomName: string;
}